<template>
  <span class="bg-gcode">
    <span class="bg-gcode-code">{{ code }}</span>
    <span class="bg-gcode-desc" v-if="description">{{ description }}</span>
    <span class="bg-gcode-value" v-if="value !== null">−{{ value | currency }}</span>
  </span>
</template>

<script>
export default {
  props: {
    code: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: null,
    },
    value: {
      type: Number,
      default: null,
    },
  },
};
</script>
